import { FC } from "react";
import { INPUT_TYPE_ICON_MAP, TInputIconProps } from "./Input.config";
import { Icon } from "@/ui/components/primitives/Icon";

export const InputIcon: FC<TInputIconProps> = ({ type, icon: iconOverride }) => {
  const icon = iconOverride ?? (type ? INPUT_TYPE_ICON_MAP[type] : undefined);
  if (!icon) { return null; }

  return (
    <Icon
      icon={icon}
      size="sm"
      className="absolute left-3 top-1/2 -translate-y-1/2"
    />
  );
};
